import api from './api';

export const classService = {
  // Get all classes with pagination and filters
  getClasses: async (params = {}) => {
    const response = await api.get('/admin/classes', { params });
    return response.data;
  },

  // Get single class
  getClass: async (id) => {
    const response = await api.get(`/admin/classes/${id}`);
    return response.data;
  },

  // Create new class
  createClass: async (classData) => {
    const response = await api.post('/admin/classes', classData);
    return response.data;
  },

  // Update class
  updateClass: async (id, classData) => {
    const response = await api.put(`/admin/classes/${id}`, classData);
    return response.data;
  },

  // Delete class
  deleteClass: async (id) => {
    const response = await api.delete(`/admin/classes/${id}`);
    return response.data;
  },

  // Get class statistics
  getStats: async () => {
    const response = await api.get('/admin/classes/stats');
    return response.data;
  },

  // Upload file for downloadable materials
  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post('/admin/classes/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
};